module.exports = __webpack_public_path__ + "media/images/vp/icon.rightarrow2.red-94643987f773efa6818b80b36df3d209.png";